import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Seo } from "@/components/Seo";
import { ArrowRight } from "lucide-react";

const fmtDate = (d) => d ? new Date(d).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" }) : "";

export default function News() {
  const [news, setNews] = useState(null);
  useEffect(() => { api.get("/news").then((r) => setNews(r.data)).catch(() => setNews([])); }, []);

  return (
    <div className="mx-auto max-w-6xl px-4 sm:px-6 py-12" data-testid="news-page">
      <Seo title="Latest news & updates" description="News, updates and stories from Get Skilled in Days Not Years." path="/news" />
      <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[var(--accent)]">Latest news</span>
      <h1 className="font-display font-extrabold text-4xl sm:text-5xl tracking-tighter mt-2 mb-10">News &amp; updates</h1>

      {news === null && <div className="py-20 text-center text-[var(--ink-2)]">Loading…</div>}
      {news && news.length === 0 && <div className="border border-[var(--line)] bg-white py-20 text-center text-[var(--ink-2)]" data-testid="news-empty">No news yet. Check back soon.</div>}

      <div className="grid grid-cols-1 md:grid-cols-3 border-l border-t border-[var(--line)]">
        {news?.map((n) => (
          <Link key={n.id} to={`/news/${n.slug}`} className="group border-r border-b border-[var(--line)] flex flex-col hover:bg-[var(--alt)] transition-colors" data-testid={`news-list-${n.slug}`}>
            {n.cover_url
              ? <div className="aspect-video overflow-hidden"><img src={n.cover_url} alt={n.title} className="w-full h-full object-cover transition-all duration-500" /></div>
              : <div className="aspect-video bg-[var(--alt)]" />}
            <div className="p-6 flex flex-col flex-1">
              <span className="text-xs font-semibold uppercase tracking-[0.16em] text-[var(--ink-2)]">{fmtDate(n.published_at)}</span>
              <h2 className="font-display font-bold text-xl tracking-tight mt-2 mb-2 leading-snug">{n.title}</h2>
              <p className="text-sm text-[var(--ink-2)] line-clamp-3">{n.excerpt}</p>
              <span className="mt-4 text-sm font-semibold text-[var(--accent)] inline-flex items-center gap-1.5">Read article <ArrowRight size={15} /></span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
